<template>
  <form novalidate @submit.prevent="send">
    <div
      v-if="error"
      class="text-sm text-white text-center font-semibold bg-red mb-4 md:mb-7 p-1 rounded"
      role="alert"
    >
      {{ error }}
    </div>
    <div class="text-center mb-4 md:mb-7">
      <label class="md:text-lg" for="paint-calculator-email-input"
        >Enter your email below</label
      >
    </div>
    <div class="grid grid-cols-3 gap-2">
      <div class="col-span-3 md:col-span-2">
        <input
          id="paint-calculator-email-input"
          v-model="$v.email.$model"
          class="input h-12"
          :class="{ 'input--has-error': $v.email.$error }"
          aria-describedby="paint-calculator-email-input-error"
          type="text"
          name="email"
          placeholder="name@mail.com"
        />
      </div>
      <div class="col-span-3 md:col-span-1">
        <button
          class="btn-strong w-full h-12 cursor-pointer relative"
          type="submit"
          :disabled="isLoading"
        >
          <span
            class="transition-opacity duration-300"
            :class="{ 'relative opacity-0 z-10': isLoading }"
            >Submit</span
          >
          <transition name="fade">
            <div v-if="isLoading" class="absolute z-20">
              <LoaderSpinner class="w-5 h-5 fill-white" />
            </div>
          </transition>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import LoaderSpinner from "./ui/LoaderSpinner.vue";

export default {
  name: "SimpleEmailForm",

  components: { LoaderSpinner },

  mixins: [validationMixin],

  props: {
    error: {
      type: [String, Boolean],
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      email: "",
    };
  },

  methods: {
    send() {
      if (this.$v.$invalid) return;
      this.$emit("send", this.$v.email.$model);
    },
  },

  validations: {
    email: {
      required,
      email,
    },
  },
};
</script>
